import 'swiper/css';
import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import './project-overview.scss';
import { findAll, onBlockRender, once } from '../../global/utils/acf-preview';

// slidesPerView scales the card to the viewport so one card stays dominant with
// a peek of the next (like Figma's ~320px mobile frame), rather than a fixed
// width that looks thin on wider phones. Breakpoints match the SCSS ones:
// tablet 768, tablet-xlg 1025 (all three cards fit → static grid, no scrollbar).
function initCarousel( el: HTMLElement ): void {
	if ( ! once( el, 'ProjectCarousel' ) ) {
		return;
	}
	const scrollbar = el.parentElement?.querySelector<HTMLElement>( '.project-overview__scrollbar' );

	new Swiper( el, {
		modules: [ Scrollbar ],
		slidesPerView: 1.15,
		spaceBetween: 30,
		scrollbar: scrollbar ? { el: scrollbar, draggable: true } : false,
		breakpoints: {
			768: {
				slidesPerView: 2.2,
			},
			1025: {
				slidesPerView: 3,
			},
		},
	} );
}

onBlockRender( 'project-overview', ( root ) => {
	findAll<HTMLElement>( root, '[data-project-carousel]' ).forEach( initCarousel );
} );
